// web/js/player-sync-settings/index.ts
//
// Mount entry for the SyncSettings panel. The panel is rendered when
// the player column manager has more than one column open; the
// subscribePlayerUtilsToPlayerColumns subscriber in html/js/player_utils.js
// calls mountPlayerSyncSettings on every column-count change.

import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import SyncSettings from './SyncSettings';

export interface PlayerSyncSettingsHandle {
  unmount: () => void;
}

declare global {
  interface Window {
    mountPlayerSyncSettings?: (containerId: string) => PlayerSyncSettingsHandle | null;
  }
}

window.mountPlayerSyncSettings = function mountPlayerSyncSettings(
  containerId: string,
): PlayerSyncSettingsHandle | null {
  const container = document.getElementById(containerId);
  if (!container) {
    console.warn('SyncSettings: container not found:', containerId);
    return null;
  }
  const root: Root = createRoot(container);
  root.render(React.createElement(SyncSettings));
  return {
    unmount: () => {
      root.unmount();
    },
  };
};

export default SyncSettings;
